import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import { GlobalState } from "../../store";

export interface ServiceFeeState {
  totalAmount: number;
  orderServiceFee: number;
  serviceFeeLocations: {
    eventCode: string;
    isHeld: boolean;
    location: string;
  }[];
  orderLineItems: any[];
  totalSeats: number;
  totalAmountBreakdown?: {
    totalTaxAmount: number;
    totalTicketAmount: number;
    totalTicketFeesAmount: number;
  };
}

const initialState: ServiceFeeState = {
  totalAmount: 0,
  orderServiceFee: 0,
  serviceFeeLocations: [] as ServiceFeeState["serviceFeeLocations"],
  orderLineItems: [] as ServiceFeeState["orderLineItems"],
  totalSeats: 0,
};

export const serviceFeeState = createSlice({
  name: "serviceFee",
  initialState,
  reducers: {
    setResponse: (state, action: PayloadAction<ServiceFeeState>) => {
      return action.payload;
    },
    removeResponse: (state, action: PayloadAction<undefined>) => {
      return initialState;
    },
  },
});

const selector = (s: GlobalState) => s.data.purchaseSeats.serviceFee;
export const selectOrderServiceFee = createSelector(
  selector,
  (s) => s.orderServiceFee
);
export const selectOrderLineItems = createSelector(
  selector,
  (s) => s?.orderLineItems || []
);
export const selectServiceFeeTotal = createSelector(
  selector,
  (s) => s.totalAmount
);

export const selectServiceFeeLocations = createSelector(
  selector,
  (s) => s.serviceFeeLocations
);

export const selectServiceFeeTotalSeats = createSelector(
  selector,
  (s) => s.totalSeats
);
export const selectServiceTotalAmountBreakdown = createSelector(
  selector,
  (s) => s?.totalAmountBreakdown
);

export default serviceFeeState.reducer;
